import { useEffect, useState } from 'react';

import type { TSession } from '@crehana/compass.live-sessions';
import { differenceInMinutes } from 'date-fns';

type TUseNextLiveSessionProps = {
  sessions: TSession[];
  loading: boolean;
};

export const useNextLiveSession = ({
  sessions,
  loading,
}: TUseNextLiveSessionProps) => {
  const [nextLiveSession, setNextLiveSession] = useState<TSession>();

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentionally managed
  useEffect(() => {
    // biome-ignore lint/style/useBlockStatements: concise single-line form preferred here
    if (!sessions || !sessions[0]) return;

    const firstSession = sessions[0];
    const minutesToSession = differenceInMinutes(
      firstSession.startDate,
      new Date(),
    );

    // The session is live
    // biome-ignore lint/style/useBlockStatements: concise single-line form preferred here
    if (minutesToSession < 0 && firstSession.endDate > new Date())
      return setNextLiveSession(firstSession);

    // The session will start in less than 30 minutes
    // biome-ignore lint/style/useBlockStatements: concise single-line form preferred here
    if (minutesToSession <= 30) return setNextLiveSession(firstSession);
  }, [loading]);

  return nextLiveSession;
};
